import React, { useEffect, useMemo, useState } from "react";
// import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box } from "@mui/material";

import { TableRowSection } from "../components";
import AudioModal from "../../../../../common/AudioModal";
import ImagePreviewModal from "../../../../../common/ImagePreviewModal";
import TablePaginationSection from "../../../../../common/TablePaginationSection";
import {
  ReactionsInOrgData,
  ReactionsInOrgTableHeadCells,
  audios,
  getComparator,
  stableSort,
  images,
} from "../../../../../constants";
import { useReactionsContext } from "../../../../../providers/OrganizationAdmin/ReactionsProvider";
import TableHeadComponent from "../../../../../common/TableHeadComponent";

export default function ReactionsTable({ selected, setSelected }) {
  const {
    order,
    setOrder,
    orderBy,
    setOrderBy,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
  } = useReactionsContext();
  const [reactionsInOrg, setReactionsInOrg] = useState(ReactionsInOrgData);
  const [imagePreviewModal, setImagePreviewModal] = useState(false);
  const [audioModal, setAudioModal] = useState(false);

  useEffect(() => {
    setReactionsInOrg(ReactionsInOrgData);
  }, [ReactionsInOrgData]);

  const handleImagePreviewModalOpen = () => {
    setImagePreviewModal(true);
  };
  const handleImagePreviewModalClose = () => {
    setImagePreviewModal(false);
  };

  const handleAudioModalOpen = () => {
    setAudioModal(true);
  };
  const handleAudioModalClose = () => {
    setAudioModal(false);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page - 1 > 0
      ? Math.max(0, (1 + page - 1) * rowsPerPage - reactionsInOrg.length)
      : 0;

  const visibleRows = useMemo(
    () =>
      stableSort(reactionsInOrg, getComparator(order, orderBy)).slice(
        (page - 1) * rowsPerPage,
        (page - 1) * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage]
  );

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = visibleRows.map((n) => n.id);
      // const newSelected = reactionsInOrg.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClickRow = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    console.log(newPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    // setPage(1);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={mainContainerStyles}>
        <TableContainer style={tableContainerStyles}>
          <Table>
            <TableHeadComponent
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={visibleRows.length}
              TableHeadData={ReactionsInOrgTableHeadCells}
            />
            <TableBody>
              {visibleRows.map((row, index) => {
                const isItemSelected = isSelected(row.id);
                const labelId = `enhanced-table-checkbox-${index}`;
                const numberType = index % 2 == 0;

                return (
                  <TableRowSection
                    isItemSelected={isItemSelected}
                    row={row}
                    handleClickRow={handleClickRow}
                    numberType={numberType}
                    labelId={labelId}
                    key={index}
                    handleImagePreviewModalOpen={handleImagePreviewModalOpen}
                    handleAudioModalOpen={handleAudioModalOpen}
                  />
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}

                    {visibleRows.length === 0  && (
                        <TableRow>
                          <TableCell colSpan={9} align="center">
                            No results found
                          </TableCell>
                        </TableRow>
                      ) }

            </TableBody>
          </Table>
        </TableContainer>
        <TablePaginationSection
          count={Math.ceil(reactionsInOrg.length / rowsPerPage)}
          page={page}
          total={reactionsInOrg.length ?? 0}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <ImagePreviewModal
          modalOpen={imagePreviewModal}
          handleClose={handleImagePreviewModalClose}
          image={images.tableDummyImage}
        />
        <AudioModal
          modalOpen={audioModal}
          handleClose={handleAudioModalClose}
          audioFile={audios.audioSample}
        />
      </Paper>
    </Box>
  );
}

const mainContainerStyles = {
  width: "100%",
  mb: 2,
  border: "none",
  boxShadow: "none",
  pr: 1,
};

const tableContainerStyles = {
  border: "none",
  boxShadow: "none",
  width: "110%",
  marginTop: 20,
};
